<template>
	<div class="watch-readings-alert-history">
		<modal-box @close="onClose" :header="$t('headers.general.alert_history')" :subHeader="$t('base.watch.biometric')">
			<spinner v-if="alerts.loading"/>
			<error-box v-else-if="alerts.error" :error="alerts.error"/>
			<div v-else class="alerts-wrapper">
				<div v-if="alerts.data.length" class="idi-table alert-history">
					<div class="idi-header">
						<div class="idi-cell">{{ $t('labels.general.urgency') }}</div>
						<div class="idi-cell">{{ $t('labels.general.name') }}</div>
						<div class="idi-cell">{{ $t('labels.general.events') }}</div>
						<div class="idi-cell">{{ $t('labels.general.first') }}</div>
						<div class="idi-cell">{{ $t('labels.general.last') }}</div>
						<div class="idi-cell">{{ $t('labels.general.date') }}</div>
						<div class="idi-cell">{{ $t('labels.general.state') }}</div>
					</div>
					<!--router-link
						:to="{ name: resumeRouteName,
						params: { user_uid: user_uid, watch_id: watch_id, type_id: type_id, alert_id: alert.id }}"
						class="idi-row"
						v-for="alert in alerts.data"
						:key="alert.id">
						<div class="idi-cell grid-area-urgency">
							<span>{{ alert.urgency_type }}</span>
						</div>
						<div class="idi-cell"></div>
						<div class="idi-cell"></div>
						<div class="idi-cell"></div>
						<div class="idi-cell"></div>
						<div class="idi-cell grid-area-date">
							<span>{{ alert.date | formatDate(vue) }}</span>
						</div>
						<div class="idi-cell"></div>
					</router-link-->
					<alert-history-row
						v-for="(item, index) in alerts.data"
						:key="item.id"
						v-model="alerts.data[index]"
						:user_uid="user_uid"
						:watch_id="watch_id"
						:type_id="type_id"
						:units="units"
						class="widget-table-row"/>
				</div>
				<div v-else class="empty">
					<p>{{ $t('messages.general.no_alerts') }}</p>
				</div>
			</div>
			<!--pre>{{ alerts }}</pre-->
		</modal-box>
	</div>
</template>

<script>
import Readings from '@/utils/readings'
import ApiCollection from '@/classes/api/ApiCollection'
import AlertHistoryRow from './ReadingsAlertHistoryRow'
export default {
	components: {
		AlertHistoryRow
	},
	props: [
		'user_uid',
		'watch_id',
		'type_id'
	],
	data () {
		return {
			vue: this,
			componentName: 'watch biometric alert history',
			alerts: new ApiCollection()
		}
	},
	computed: {
		isGeofencing () {
			return parseInt(this.type_id) === Readings.TYPE_GEOFENCING
		},
		resumeRouteName () {
			return this.isGeofencing ? 'WatchGeofencingAlertViewResumeV2' : 'WatchBiometricAlertViewResumeV2'
		},
		backRouteName () {
			return this.isGeofencing ? 'WatchGeofencing' : 'WatchBiometricView'
		},
		units () {
			return this.type_id ? this.$t(Readings.readingTypes.get(parseInt(this.type_id)).translationKey + '.html') : '(no type)'
		}
	},
	methods: {
		/*getAlerts () {
			this.alerts.loading = true
			this.alerts.data = []
			this.$api.alerts.getAll(this, this.user_uid, this.watch_id, this.type_id)
				.then(response => {
					this.$log.info(this.componentName, 'alerts.getAll OK', response)()
					this.alerts.data = response.body
				}).catch(error => {
					this.$log.error(this.componentName, 'alerts.getAll ERROR', error)()
					this.alerts.error = error
				}).finally(() => {
					this.alerts.loading = false
				})
		},*/
		getAlerts () {
			this.alerts.loading = true
			this.alerts.data = []
			this.$api.alerts.getAllResume(this, this.user_uid, this.watch_id, this.type_id)
				.then(response => {
					debugger
					this.$log.info(this.componentName, 'alerts.getAllResume OK', response)()
					// STATUS_UNKNOWN = 0; STATUS_IN_PROGRESS = 1; STATUS_DONE = 2; STATUS_CANCEL = 4;
					this.alerts.data = response.body //.filter(element => !(element.status > 1))
				}).catch(error => {
					this.$log.error(this.componentName, 'alerts.getAllResume ERROR', error)()
					this.alerts.error = error
				}).finally(() => {
					this.alerts.loading = false
				})
		},
		type (type) {
			return Readings.readingTypes.get(type).route
		},
		onClose () {
			this.$router.push({ name: this.backRouteName, params: { user_uid: this.user_uid, watch_id: this.watch_id, type: this.type(this.type_id) } })
		}
	},
	created () {
		this.getAlerts()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/alertsV2/ReadingsAlertHistory.vue